/**
 * The one URL shape that opens a Connect (Work Chats) message: the channel
 * route, plus `?message=` to jump to a top-level message, or `?thread=` (the
 * thread route ref) and `?reply=` to open a thread panel at one reply.
 * Shared by push deep links, workspace search results, and toasts, so every
 * entry point lands the same way. Pure: no Convex or browser imports.
 */
export type ChannelMessageTarget = {
  channelId: string;
  messageId?: string;
  threadMessageId?: string;
  routeRef?: string;
};

export const MESSAGE_JUMP_PARAM = 'message';
export const THREAD_PARAM = 'thread';
export const REPLY_JUMP_PARAM = 'reply';

export function buildChannelMessageHref(
  orgSlug: string,
  target: ChannelMessageTarget
): string {
  const base = `/${encodeURIComponent(orgSlug)}/chats/${encodeURIComponent(
    target.channelId
  )}`;
  const params = new URLSearchParams();
  if (target.routeRef) {
    params.set(THREAD_PARAM, target.routeRef);
    if (target.threadMessageId) {
      params.set(REPLY_JUMP_PARAM, target.threadMessageId);
    }
  } else if (target.messageId) {
    params.set(MESSAGE_JUMP_PARAM, target.messageId);
  }
  const query = params.toString();
  return query ? `${base}?${query}` : base;
}
